/*
 UdostepnianieDanych

 Tresc polityki prywatnosci Udostępnianie danych firmom trzecim dla wszystkich aplikacji 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

class UdostepnianieDanych extends React.Component<any, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Udostępnianie danych firmom trzecim</b></Typography>
                <Typography variant='body2'>
                    Aplikacja nie zbiera żadnych danych osobowych ani innych danych użytkowników w celach marketingowych ani reklamowych. Dane nie są udostępniane firmom trzecim.
                </Typography>
            </React.Fragment>
        );
    }
}

export default UdostepnianieDanych;
